<template>
    <div>
        <div id="header-container" class="px-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Individual Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <Individual
                                class="p-3"
                                :information = information
                                :account_id = account_id
                                :user_no = user_no
                                @on-error = "onError"
                                @file-uploaded = "fileUploaded"
                                ref="Individual"
                            ></Individual>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <button @click="submit" class="ml-auto btn btn-primary d-block mb-5">{{ $t('Submit') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import Individual from '@/components/CardManagement/individual';
    import CreateAccount from '@/services/CreateAccount';
    import Account from "@/services/Account";
  
    export default {
        name: 'individual-account',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                account_id : '',
                user_no : '',
                information : ''
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            Individual
        },
        methods:{
            getMessage: function (key) {
                return this.$t(key)
            },
            submit(){
                this.isLoading = true;
                if(this.$refs['Individual'].validate()){
                    if(this.user_no){
                        this.$refs['Individual'].uploadFile(this.account_id,this.user_no);
                    }
                    else{
                        CreateAccount.createType({"userType":1}).then(response => {
                            const data = response.data.data;
                            this.user_no = data['userNo'];
                            this.account_id = data['accountId'];
                            this.$refs['Individual'].uploadFile(data['accountId'],data['userNo']);
                        }).catch(err => {
                            this.checkError(err);
                        });
                    }
                }
                else{
                    this.isLoading = false;
                }
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let IndividualAcc = this.$refs['Individual'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    if(typeof IndividualAcc.error[key] !== "undefined"){
                                        IndividualAcc.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            onError(){
                this.isLoading = false;
            },
            fileUploaded(){
                
                let IndividualAcc = this.$refs['Individual'];

                let params = {
                    "accountId":this.account_id,
                    "userNo":""+this.user_no,
                    "idFront":IndividualAcc.file.idFront,
                    "idReverse":IndividualAcc.file.idReverse,
                    "idHold":IndividualAcc.file.idHold,
                    "idNo":IndividualAcc.params.idNo,
                    "name":IndividualAcc.params.name,
                    "enName":IndividualAcc.params.enName,
                    "legalCertExpiryDate":IndividualAcc.params.legalCertExpiryDate,
                    "birthDate" : IndividualAcc.params.birthDate,
                    "province" : IndividualAcc.params.province,
                    "city" : IndividualAcc.params.city,
                    "area" : IndividualAcc.params.area,
                    "address" : IndividualAcc.params.address,
                    "postCode" : IndividualAcc.params.postCode
                };

                Account.updateIndividual(params).then(response => {
                    const data = response.data.data;
                    this.submitData(params);
                }).catch(err => {
                    this.checkError(err);
                });
            },
            submitData(individual_data){
                let params = {
                    ...this.information,
                    ...individual_data
                };

                CreateAccount.individual(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$swal({
                        icon: 'success',
                        title: 'success',
                        showConfirmButton: true,
                    }).then((result) => {
                        window.parent.location.href = location.protocol+"//"+window.location.hostname;
                    });
                }).catch(err => {
                    this.checkError(err);
                });
            },
        },
        mounted() {
            this.init = false;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        if(response.data.data.length>0){
                            this.account_id = response.data.data[0]['id'];
                            this.user_no = response.data.data[0]['userNo'];
                            this.information = response.data.data[0]['information'];
                        }
                        this.init = true;
                    }
                });
            });
        },
    };
  </script>